export default "assets/images/icons/go-858a7c64.svg";